document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.media-gallery-thumbs').forEach(gallery => {
    const thumbs = gallery.querySelectorAll('.media-gallery-thumbs__thumb')
    const items = gallery.querySelectorAll('.media-gallery__item')
    const thumbsWrap = gallery.querySelector('.media-gallery-thumbs__thumbs')
    const prev = gallery.querySelector('.media-gallery-arrow--prev')
    const next = gallery.querySelector('.media-gallery-arrow--next')

    if (!thumbs.length || !items.length) return

    const syncThumbsHeight = () => {
    if (!thumbsWrap) return

    const imageItems = gallery.querySelectorAll(
        '.media-gallery__item img'
    )

    let maxHeight = 0

    imageItems.forEach(img => {
        if (!img.complete) return
        const h = img.getBoundingClientRect().height
        if (h > maxHeight) maxHeight = h
    })

    if (maxHeight > 0) {
        thumbsWrap.style.maxHeight = `${maxHeight}px`
    }
    }


    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'))
        items.forEach(i => i.classList.remove('active'))

        thumb.classList.add('active')
        items[index]?.classList.add('active')

        syncThumbsHeight()
      })
    })

    const isVisible = element => !element.hidden

    const getVisibleItems = () => [...items].filter(isVisible)

    const getActiveIndex = visibleItems =>
      visibleItems.findIndex(i => i.classList.contains('active'))

    const setActive = index => {
        items.forEach(i => i.classList.remove('active'))
        thumbs.forEach(t => t.classList.remove('active'))

        items[index]?.classList.add('active')
        thumbs[index]?.classList.add('active')

        thumbs[index]?.scrollIntoView({
            block: 'nearest',
            behavior: 'smooth'
        })

        syncThumbsHeight()
        }


    prev?.addEventListener('click', () => {
      const visibleItems = getVisibleItems()
      if (!visibleItems.length) return

      let visibleIndex = getActiveIndex(visibleItems) - 1
      if (visibleIndex < 0) visibleIndex = visibleItems.length - 1
      setActive([...items].indexOf(visibleItems[visibleIndex]))
    })

    next?.addEventListener('click', () => {
      const visibleItems = getVisibleItems()
      if (!visibleItems.length) return

      let visibleIndex = getActiveIndex(visibleItems) + 1
      if (visibleIndex >= visibleItems.length) visibleIndex = 0
      setActive([...items].indexOf(visibleItems[visibleIndex]))
    })

    const images = gallery.querySelectorAll('img')
    let loaded = 0

    images.forEach(img => {
    if (img.complete) {
        loaded++
    } else {
        img.addEventListener('load', () => {
        loaded++
        if (loaded === images.length) {
            syncThumbsHeight()
            gallery.classList.add('is-ready')
        }
        })
    }
    })

    if (loaded === images.length) {
    syncThumbsHeight()
    gallery.classList.add('is-ready')
    }
    window.addEventListener('resize', syncThumbsHeight)
  })
})
